<template>
  <div class="mb-3 news-list">
    <div
      class="mb-4"
      v-for="(date, name) in items"
      :key="name"
    >
      <div class="group-date mb-4 success--text">
        {{ name }}
      </div>
      <div
        @click="$emit('openNewsDialog', newsItem)"
        v-for="(newsItem, index) in date"
        class="mb-4"
        :key="'items_' + index"
      >
        <v-card
          elevation="0"
          class="d-flex"
        >
          <div
            class="card--line ma-2 mr-0"
            :style="
              `border-color: ${getSchoolColour(
                newsItem.domain
              )}; background-color: ${getSchoolColour(newsItem.domain)}`
            "
          >
            &nbsp;
          </div>
          <div style="min-height:133px;flex-grow:1">
            <div class="d-flex flex-start">
              <div
                class="d-flex flex-column"
                style="flex-grow:1;"
              >
                <v-card
                  class="grow"
                  flat
                >
                  <v-card-title
                    :class="
                      `px-3 pt-2 pb-0 mb-3 card--title ${
                        $store.getters['readArticles'].find(
                          a => a === newsItem.id
                        )
                          ? 'read'
                          : null
                      }`
                    "
                  >
                    {{ newsItem.title }}
                  </v-card-title>
                  <v-card-text
                    style="min-height:70px"
                    class="pa-3 pt-0 card--description"
                  >
                    {{ getDescription(newsItem.description) }}
                  </v-card-text>
                </v-card>
              </div>
              <div
                class="d-flex flex-column"
                :class="newsItem.image ? 'shrink' : ''"
              >
                <div
                  v-if="newsItem.image"
                  tabindex="0"
                  aria-label="news picture"
                  class="pa-3 pl-1 image--content align-right"
                >
                  <v-img
                    class="image--border"
                    alt="news picture"
                    height="110px"
                    width="147px"
                    :src="newsItem.image"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="newsItem.domain"
              class="d-flex flex-row grow px-3 pb-2 pt-0"
            >
              <div class="align-self-end">
                <div class="d-flex align-center">
                  <div
                    class="school-logo"
                    :style="`border-color: ${getSchoolColour(newsItem.domain)}`"
                  >
                    <v-img
                      v-if="newsItem.domain != 'global'"
                      width="20"
                      height="20"
                      class="flex-grow-0 flex-shrink-0"
                      :src="getLogo(newsItem.domain)"
                    />
                    <v-img
                      v-else
                      width="20"
                      height="20"
                      class="flex-grow-0 flex-shrink-0"
                      src="/NSWGov_Logo-40.png"
                    />
                  </div>
                  <span
                    class="pl-2 flex-shrink-0"
                    :aria-label="'created on ' + newsItem.created"
                  >
                    {{ getDate(newsItem.created) }}
                  </span>
                  <ul
                    class="ml-2"
                    v-if="newsItem.tags.length > 0"
                  >
                    <li class="school-tags">
                      <div
                        v-for="(tag, i) in newsItem.tags"
                        class="d-inline-block mr-2"
                        :key="`tags_${i}`"
                      >
                        {{ tag }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import { AppIcon } from "@nswdoe/doe-ui-core";

const newsList = {
  name: "newsList",
  components: {
    AppIcon
  },
  methods: {
    getLogo(schoolId) {
      if (schoolId != "global") {
        return this.schoolImages.find(
          schoolInfo => schoolInfo.schoolId == schoolId
        )
          ? this.schoolImages.find(
              schoolInfo => schoolInfo.schoolId == schoolId
            ).logo
          : null;
      }
      return "nsw_logo.svg";
    },
    getSchoolColour(schoolId) {
      if (schoolId != "global") {
        return this.schoolImages.find(
          schoolInfo => schoolInfo.schoolId == schoolId
        )?.colour;
      }
      return "#264189";
    },
    getDate(date) {
      let dateString = new Date(date).toLocaleDateString("en-us");
      if (this.getToday(dateString)) {
        return this.$t("news.today");
      } else if (this.getYesterday(dateString)) {
        return this.$t("news.yesterday");
      } else if (date === "Featured") {
        return this.$t("news.featured");
      } else {
        return new Date(date).toLocaleDateString(this.getLocale(), {
          year: "numeric",
          month: "long",
          day: "numeric"
        });
      }
    },
    getToday(dateString) {
      return dateString === new Date().toLocaleDateString("en-us")
        ? true
        : false;
    },
    getYesterday(dateString) {
      let yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return dateString === yesterday.toLocaleDateString("en-us")
        ? true
        : false;
    },
    getDescription(description) {
      return `${description.substr(0, 100)} ${
        description.substr(0, 100).length < 100 ? "" : "..."
      }`;
    }
  },
  props: {
    items: {
      type: Object,
      default: function() {
        return {};
      }
    },
    schoolImages: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};

export default newsList;
</script>
<style lang="scss" scoped>
.v-card__title.card--title {
  word-break: break-word;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
}
.v-card__text.card--description {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #4c4f55;
  word-break: break-word;
}
.card--line {
  border: 1px solid #1d428a;
  max-width: 3px;
  border-radius: 3px;
  background-color: #1d428a;
}

.image--content {
  width: 150px;
  max-width: 150px;
}
.news-list {
  .v-sheet.v-card {
    border: 1px solid #c8dcf0 !important;
    border-radius: 7px !important;
  }
  .v-card .v-card {
    border: none !important;
    border-radius: 0 !important;
  }
}
.image--border {
  border: 1px solid #fff !important;
  border-radius: 5px;
}
.group-date {
  font-size: 18px;
  color: $ads-blue-1;
  font-weight: 500;
}
.school-tags::marker {
  color: #dde9f6;
}
.school-logo {
  padding: 5px;
  border: 2px solid;
  border-radius: 100px;
}
.read {
  color: rgba(0, 0, 0, 0.6);
}
</style>
